import type { ReactNode } from 'react'
import { IntlayerProvider } from 'react-intlayer'
import type { Locale } from '../domain/locale'
import { defaultLocale } from '../domain/locale'

type Props = {
	locale?: Locale
	children: ReactNode
}

const LocaleProvider = ({ locale = defaultLocale, children }: Props) => (
	<IntlayerProvider locale={locale}>{children}</IntlayerProvider>
)

export { LocaleProvider }
